import { Card, CardContent, Typography } from "@mui/material";

export default function StatCard({ label, value }) {
  return (
    <Card sx={{ borderRadius: 3, boxShadow: "0 12px 30px rgba(14,59,67,0.08)" }}>
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="h4" fontWeight={700} sx={{ mt: 1 }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
}
